import Card from "components/card";
import Loader from "components/loader";
import useStats from "hooks/useStats";
import { useEffect } from "react";
import { Table, Tag } from "antd";
import { Link } from "react-router-dom";
import { routesNames } from "utils/Constants";

const columns = [
  {
    title: "Institución",
    dataIndex: "institucion",
  },
  {
    title: "Puesto",
    dataIndex: "puesto",
    render: (text, record) => (
      record?.publicacion_id ? (
        <Link to={`${routesNames.PUBLICATION}/${record.publicacion_id}`} className="text-sm font-semibold text-blue-800 dark:text-white">
          {text}
        </Link>
      ) : (
        text
      )
    ),
  },
  {
    title: "Estado",
    dataIndex: "estado",
    render: (text) => (text ? <Tag>{text}</Tag> : "—"),
  },
  {
    title: "Postulaciones",
    dataIndex: "postulaciones",
  },
];

const TopPublicacionesTable = () => {
  const { isLoading, response, fetchData } = useStats("top-publicaciones");

  useEffect(() => {
    fetchData(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const rows = Array.isArray(response) ? response : [];

  return (
    <Card extra="w-full h-full px-6 py-4">
      <div className="text-xl font-bold text-navy-700 dark:text-white mb-2">
        Top 10 publicaciones con más postulaciones
      </div>

      {isLoading ? (
        <Loader />
      ) : (
        <Table
          columns={columns}
          dataSource={rows}
          rowKey={(record) => record.publicacion_id}
          size="small"
          pagination={false}
          locale={{ emptyText: "No hay datos disponibles" }}
        />
      )}
    </Card>
  );
};

export default TopPublicacionesTable;
